export const normalizeI18Key = (key: string): [string] => [key];
